<div class="component-container h-full flex flex-col justify-center">
  <div class="heading">
    Enter Data
  </div>
  <hr>
  <div id="measurement-value-entry" class="content">
    <div class="row flex flex-row justify-between items-center">
      <div class="label w-1/2">
        Date
      </div>
      <app-date-picker
        class="date-picker-input w-1/2"
        [parentFormGroup]="form"
        controlName="recordedOn"
        [max]="maxDate"
        [error]="errorMessages['recordedOn']"
        (checkForErrors)="checkForErrors($event)"
        placeholder="Select a date"
        type="small"
      ></app-date-picker>
    </div>

    <div
      *ngFor="let eachOption of data['metricsOptions']"
      [ngSwitch]="eachOption.code"
      class="measurement-inputs"
    >
      <div *ngSwitchCase="constants.metricOption.weight">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{eachOption.name}}
          </div>
          <app-number-input
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="weight"
            [error]="errorMessages['weight']"
            placeholder="000.00"
            type="small"
          ></app-number-input>
        </div>
      </div>

      <div *ngSwitchCase="constants.metricOption.height">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{eachOption.name}}
          </div>
          <app-height-input
            id="measurement-height-input"
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="height"
            [error]="errorMessages['height']"
            placeholder="00"
            type="small"
          ></app-height-input>
        </div>
      </div>

      <div *ngSwitchCase="constants.metricOption.bp">
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{eachOption.name}}
          </div>
          <app-blood-pressure-input
            id="measurement-bp-input"
            class="w-1/2"
            [parentFormGroup]="form"
            controlName="bp"
            [error]="errorMessages['bp']"
            placeholder="sys/dia"
            type="small"
            (checkForErrors)="checkForErrors($event)"
          ></app-blood-pressure-input>
        </div>
      </div>

      <div *ngSwitchDefault>
        <div class="row flex flex-row justify-between items-center">
          <div class="label w-1/2">
            {{eachOption.name}}
          </div>
          <ng-container
            *ngIf="eachOption.type===1;else numberInputComponent;">
            <app-text-input
              class="w-1/2"
              [parentFormGroup]="form"
              [controlName]="eachOption.code"
              [error]="errorMessages[eachOption.code]"
              placeholder=""
              [minLength]="0"
              type="small"
            ></app-text-input>
          </ng-container>
          <ng-template #numberInputComponent>
            <app-number-input
              class="w-1/2"
              [parentFormGroup]="form"
              [controlName]="eachOption.code"
              [error]="errorMessages[eachOption.code]"
              placeholder="00"
              type="small"
            ></app-number-input>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="oldDataExists" class="note">
    *Measurements for this date exists. You can update them here.
  </div>
  <hr>
  <div class="action-panel flex flex-row justify-end items-center">
    <div
      class="icon-panel-submit w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleSubmit()"
    >
      <app-icon icon="check" cssClass="icon-panel-icon"></app-icon>
    </div>
    <div
      class="icon-panel-cancel w-[4rem] h-[4rem] flex justify-center items-center"
      (click)="handleCancel()"
    >
      <app-icon icon="close" cssClass="icon-panel-icon"></app-icon>
    </div>
  </div>
</div>
